<template>
  <v-app>
    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view v-model="expandOnHover"/>
<!--    <dashboard-core-footer v-model="expandOnHover" />-->
  </v-app>
</template>

<script>
  import {eventBus} from "@/services/event-bus";

  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      // DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
      // DashboardCoreFooter: () => import('./components/core/Footer'),

    },
    mounted() {
      this.$vuetify.theme.themes[this.isDark ? 'dark' : 'light'].primary =  '#FF5252';
      eventBus.$on('set-drawer', (val) => {
        this.expandOnHover = val
      })
    },

    data: () => ({
      expandOnHover: false,
    }),
  }
</script>
